var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"ripple":false,"elevation":"0"}},'v-btn',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(s,name){return _vm._t(name)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }